import React, { useContext, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Typography,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import clsx from "clsx";

import { viewportContext } from "../../../context/ViewportContext";
import styles from "../../../styles.module.css";

const NarcoticsDataSummaryTable = ({ aggregatedData, timeUnits }) => {
  const { screenType } = useContext(viewportContext);

  const exportPDF = () => {
    const currentTimeUnits = timeUnits.map((unit) => unit.replace(/^0/, ""));
    const normalizedTimeUnits = [];
    currentTimeUnits.forEach((unit) => {
      normalizedTimeUnits.push(`${unit} (Qualitative)`);
      normalizedTimeUnits.push(`${unit} (Quantitative)`);
    });

    const doc = new jsPDF();
    doc.text("Compliance Report", 10, 10);
    if (aggregatedData && Object.keys(aggregatedData).length > 0) {
      doc.autoTable({
        head: [["Observation Point", ...normalizedTimeUnits]],
        body: generateTableData(),
      });
    }
    doc.save("narcotics_compliance_summary_report.pdf");
  };

  // separate qualitative and quantitative records and format them to display in table
  const generateTableData = () => {
    const data = [];
    if (!aggregatedData || Object.keys(aggregatedData).length === 0) {
      return data;
    }

    const observationPoints = Object.keys(aggregatedData);

    // Normalize the date formats in timeUnits to match the data keys
    const currentTimeUnits = timeUnits.map((unit) => unit.replace(/^0/, ""));

    const normalizedTimeUnits = [];

    currentTimeUnits.forEach((unit) => {
      normalizedTimeUnits.push(`${unit} (Qualitative)`);
      normalizedTimeUnits.push(`${unit} (Quantitative)`);
    });

    // console.log("Normalized Time Units: \n", normalizedTimeUnits);

    observationPoints.forEach((point) => {
      const dataRow = [`${point}`];

      currentTimeUnits.forEach((unit) => {
        dataRow.push(
          aggregatedData[point][unit]?.qualitative_compliance || "-"
        );
        dataRow.push(
          aggregatedData[point][unit]?.quantitative_compliance || "-"
        );
      });

      data.push(dataRow);
    });

    return data;
  };

  const observationPoints = Object.keys(aggregatedData);

  // useEffect(() => {
  //   console.log("Aggregated Data: \n", aggregatedData);
  // }, [aggregatedData]);

  // console.log("Time Units: \n", timeUnits);

  if (!aggregatedData || Object.keys(aggregatedData).length === 0) {
    return (
      <Paper className={styles.paperStyles}>
        <Typography variant="h5">No data available Yet ...</Typography>
      </Paper>
    );
  }

  return (
    <Paper className={styles.paperStyles}>
      <div className={styles.titleButtonRow}>
        <Typography variant="h5">Summary</Typography>
        <div className={styles.exportButtonContainer}>
          <Button
            onClick={exportPDF}
            className={clsx(
              styles.secondaryButton,
              styles.complianceTableButtons
            )}
          >
            {screenType.isMobile ? "PDF" : "Export PDF"}
          </Button>
        </div>
      </div>

      <TableContainer className={styles.narcoticsDataSummaryTable}>
        <Table stickyHeader>
          <TableHead>
            <TableRow className={styles.narcoticsReportHeader}>
              <TableCell>Observation Point</TableCell>
              {timeUnits.map((unit) => (
                <>
                  <TableCell
                    key={`${unit} quantitative`}
                    className={styles.textCenteredTableCell}
                  >
                    {unit}
                    <br />
                    (Qualitative)
                  </TableCell>
                  <TableCell
                    key={`${unit} qualitative`}
                    className={styles.textCenteredTableCell}
                  >
                    {unit}
                    <br />
                    (Quantitative)
                  </TableCell>
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {observationPoints.map((point) => (
              <React.Fragment key={point}>
                <TableRow>
                  <TableCell>{point}</TableCell>
                  {timeUnits.map((unit) => (
                    <>
                      <TableCell
                        className={styles.textCenteredTableCell}
                        key={`${point}-qualitative-${unit}`}
                      >
                        {aggregatedData[point][unit.replace(/^0/, "")]
                          ?.qualitative_compliance
                          ? `${
                              aggregatedData[point][unit.replace(/^0/, "")]
                                ?.qualitative_compliance
                            }% (${
                              aggregatedData[point][unit.replace(/^0/, "")]
                                ?.qualitative_records
                            })`
                          : "-"}
                      </TableCell>
                      <TableCell
                        className={styles.textCenteredTableCell}
                        key={`${point}-quantitative-${unit}`}
                      >
                        {aggregatedData[point][unit.replace(/^0/, "")]
                          ?.quantitative_compliance
                          ? `${
                              aggregatedData[point][unit.replace(/^0/, "")]
                                ?.quantitative_compliance
                            }% (${
                              aggregatedData[point][unit.replace(/^0/, "")]
                                ?.quantitative_records
                            })`
                          : "-"}
                      </TableCell>
                    </>
                  ))}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default NarcoticsDataSummaryTable;
